/**
 * Header scroll effect
 */
export function initHeaderScrollEffect() {
    const header = document.querySelector('#header');
    if (!header) return;

    let lastScrollTop = 0;
    const delta = 5;
    let currentHeaderTop = 0;

    window.addEventListener('scroll', () => {
        const headerHeight = header.offsetHeight;
        let currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

        currentScrollTop = Math.max(0, currentScrollTop);

        if (Math.abs(lastScrollTop - currentScrollTop) <= delta) return;

        if (currentScrollTop < delta && currentHeaderTop > 0) {
            currentHeaderTop = 0;
        }

        const scrollDown = currentScrollTop > lastScrollTop;
        const scrollDifference = Math.abs(currentScrollTop - lastScrollTop);

        if (scrollDown) {
            currentHeaderTop -= scrollDifference;
            if (currentHeaderTop < -headerHeight) currentHeaderTop = -headerHeight;
        } else {
            currentHeaderTop += scrollDifference;
            if (currentHeaderTop > 0) currentHeaderTop = 0;
        }

        header.style.top = `${currentHeaderTop}px`;
        lastScrollTop = currentScrollTop;
    }, false);
}

/**
 * Bottom scroll
 */
export function initBottomScroll() {
	const triggers = document.querySelectorAll('[data-scroll-target]');

	triggers.forEach(trigger => {
		trigger.addEventListener('click', (e) => {
			e.preventDefault();

			const targetName = trigger.dataset.scrollTarget;
			const targetSection = document.getElementById(`section-${targetName}`);

			if (targetSection) {
				const offset = window.innerWidth >= 1280 ? 80 : 60;
				const rect = targetSection.getBoundingClientRect();
				const absoluteSectionBottom = window.scrollY + rect.bottom;
				const viewportHeight = window.innerHeight;
				const scrollToPosition = absoluteSectionBottom - viewportHeight + offset;

				window.scrollTo({
					top: scrollToPosition,
					behavior: 'smooth'
				});
			}
		});
	});
}

/**
 * Consultation scroll
 */
export function initConsultationScroll() {
    const button = document.getElementById('trigger-consultation');
    const target = document.getElementById('consultation');

    if (button && target) {
        button.addEventListener('click', function(e) {
            e.preventDefault();

            target.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        });
    }
}

/**
 *
 * Anchor scroll
 */
export function initAnchorScroll(selector = 'a[href*="#"]') {
	document.querySelectorAll(selector).forEach((anchor) => {
		anchor.addEventListener("click", (e) => {
			const href = anchor.getAttribute("href");
			const hashIndex = href.indexOf("#");

			if (hashIndex === -1) return;

			const hash = href.slice(hashIndex);
			const targetId = hash.slice(1);
			const isSamePage =
				href.startsWith("#") ||
				href.startsWith(window.location.pathname + "#") ||
				new URL(href, window.location.origin).pathname === window.location.pathname;

			if (!isSamePage) return;

			const target = document.getElementById(targetId);

			if (!target) return;

			e.preventDefault();

			target.scrollIntoView({ behavior: "smooth" });
		});
	});
}
